/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';

const DurationDropdown = ({handleOptionClick, noProductScanned, selectedFilter,GraphKey}) => {
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef(null);

    const handleDocumentClick = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            // Clicked outside the dropdown
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, []);

    const options = [
        { value: 'seven_days', label: 'Last 7 days' },
        { value: 'six_weeks', label: 'Last  6 weeks' },
        { value: 'six_months', label: 'Last 6 months' },
        { value: 'six_years', label: 'Last 6 years' }
    ];
    const handleLable = () => {
        let lable = ""
        switch (selectedFilter) {
        case "seven_days":
            lable = 'Last 7 days'
            break;
        case "six_weeks":
            lable ='Last  6 weeks'
            break;
        case "six_months":
            lable = 'Last 6 months'
            break;
        case "six_years":
            lable = 'Last 6 years'
            break;
        
        default:
            break;
        }
        return lable;
    }
    return (
        <div className="relative inline-bloc w-[133px] ml-5 h-9">
            <button
                data-testid={`day-dropdown-${GraphKey}`}
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center justify-between px-4 h-full w-full border-2 border-[#CDCDCD] rounded-md font-normal text-xs text-black"
            >
                {handleLable()}
                <img
                    className={`ml-2 h-5 w-5 transition-transform duration-300 transform ${isOpen ? 'rotate-180' : ''}`}
                    src="/assets/images/Black-down-arrow.svg"
                    alt="Arrow"
                    onClick={() => setIsOpen(!isOpen)}
                />

            </button>
            {isOpen && (
                <div className="absolute z-10 w-full bg-white shadow-lg rounded-md">
                    {options.map((option) => (
                        <button
                            key={option.value}
                            data-testid={`${GraphKey}-${option.value}`}
                            onClick={() => {
                                handleOptionClick(option.value, "duration")
                                setIsOpen(false)
                            }}
                            className="block w-full px-4 py-2 text-left hover:bg-[#EB9DC7] focus:outline-none border border-[#CDCDCD] rounded font-normal text-xs text-black"
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DurationDropdown;
